"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteView = exports.createView = exports.updateView = exports.getViews = void 0;

var cimpress_tagliatelle_1 = __importDefault(require("cimpress-tagliatelle"));

var v4_1 = __importDefault(require("uuid/v4"));

var VIEWS_URN = 'urn:pom:views';
var VIEW_URI_PREFIX = 'https://production.cimpress.io/configuration/views/';
var defaultTagliatelle = {
  autoFetchPagedResults: true,
  timeout: 10000
};

var getClient = function getClient(opts) {
  var opt = opts || {};
  return new cimpress_tagliatelle_1["default"](Object.assign(Object.assign({}, defaultTagliatelle), opt));
};

var getViews = function getViews(accessToken, options) {
  var client = getClient(options);
  return client.getTags(accessToken, {
    key: VIEWS_URN
  }).then(function (tags) {
    var jsonTags = tags.results.map(function (x) {
      return JSON.parse(x.value);
    });
    jsonTags.sort(function (a, b) {
      return a.orderingNumber > b.orderingNumber;
    });
    return jsonTags;
  })["catch"](function (error) {
    // TODO: Errors....
    throw error;
  });
};

exports.getViews = getViews;

var updateView = function updateView(accessToken, viewId, viewObject) {
  var client = getClient({});
  var viewUri = "".concat(VIEW_URI_PREFIX).concat(viewId);
  var viewObjectCopy = Object.assign({}, viewObject);
  viewObjectCopy.viewId = viewId;
  return client.createOrUpdateTag(accessToken, viewUri, VIEWS_URN, JSON.stringify(viewObjectCopy)).then(function (newTag) {
    return newTag.value;
  });
};

exports.updateView = updateView;

var createView = function createView(accessToken, viewObject) {
  var viewId = (0, v4_1["default"])();
  return updateView(accessToken, viewId, viewObject);
};

exports.createView = createView;

var deleteView = function deleteView(accessToken, viewId) {
  var client = getClient({});
  var viewUri = "".concat(VIEW_URI_PREFIX).concat(viewId);
  return client.getTagByResourceAndKey(accessToken, viewUri, VIEWS_URN).then(function (tag) {
    return client.deleteTag(accessToken, tag.id);
  });
};

exports.deleteView = deleteView;